import { composeIO } from 'react-compose-io'
import { parceirosIO } from './Parceiros.IO'
import ParceirosView from './Parceiros.View'

export const Parceiros = composeIO(ParceirosView, parceirosIO)
